import { FileStack, Hourglass, ReceiptText, Building2 } from "lucide-react";
import { Reveal, SectionLabel } from "./shared";
import { useLang } from "./i18n";

const ICONS = [FileStack, Hourglass, ReceiptText, Building2];

export function Problem() {
  const { t } = useLang();
  return (
    <section className="bg-paper py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <SectionLabel>{t.problem.label}</SectionLabel>
            <h2 className="font-display text-4xl font-semibold leading-[1.1] tracking-[-0.02em] text-ink md:text-5xl">
              {t.problem.titleA} <span className="italic text-aqua-700">{t.problem.titleB}</span>
            </h2>
            <p className="mt-6 text-base leading-relaxed text-slate-500 md:text-lg">{t.problem.intro}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid gap-5 md:grid-cols-2">
          {t.problem.cards.map((p, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={i} delay={i * 0.08}>
                <div
                  data-testid={`problem-card-${i}`}
                  className="group flex h-full gap-6 rounded-3xl border border-slate-200 bg-white p-7 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1 hover:border-aqua-600/30 hover:shadow-[0_16px_48px_rgba(14,124,147,0.08)] md:p-8"
                >
                  <span className="font-display text-6xl font-semibold leading-none text-navy/10 transition-colors duration-300 group-hover:text-maple/30 md:text-7xl">
                    0{i + 1}
                  </span>
                  <div>
                    <span className="mb-4 flex h-11 w-11 items-center justify-center rounded-2xl bg-navy text-aqua-300">
                      <Icon size={19} />
                    </span>
                    <h3 className="font-display text-xl font-semibold text-ink">{p.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-slate-500">{p.desc}</p>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
